module.exports = __webpack_public_path__ + "img/agent-banner.1f629074.png";